import { useState } from "react";
import { faqItems } from "@/mocks/gallery";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="mx-auto max-w-4xl scroll-mt-20 px-4 py-14 md:px-6 md:py-20">
      <div className="text-center">
        <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-widest text-primary-600">
          <i className="ri-question-line"></i>
          FAQ
        </span>
        <h2 className="mt-2 font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">
          常见问题
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">
          关于作品收藏、更新与投稿的疑问,这里都有解答。
        </p>
      </div>

      <div className="mt-10 space-y-3">
        {faqItems.map((f, i) => {
          const open = openIdx === i;
          return (
            <div
              key={f.q}
              className={`rounded-lg border transition-colors ${
                open ? "border-primary-200 bg-primary-50/50" : "border-background-200 bg-background-100"
              }`}
            >
              <button
                onClick={() => setOpenIdx(open ? null : i)}
                className="flex w-full items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="font-heading text-sm font-medium text-foreground-950 md:text-base">
                  {f.q}
                </span>
                <span
                  className={`ml-4 flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-transform ${
                    open ? "rotate-45 bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                  }`}
                >
                  <i className="ri-add-line text-lg"></i>
                </span>
              </button>
              {open && (
                <div className="px-5 pb-5 text-sm leading-relaxed text-foreground-700">{f.a}</div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}